import React from "react";
import DownloadIcon from "@mui/icons-material/Download";
import { useApi } from "utils/hooks/use-api";
import { logService } from "api/services/logs";
import Button from "components/shared-ui/button";
import styles from "./download.module.scss";

export interface IDownloadButtonProps {
  namespace: string;
  pod: string;
  podId: string;
  podIp: string;
  container: string;
  fileName: string;
}

export const AppLogDownloadButton = (props: IDownloadButtonProps) => {
  const [logsApi] = useApi();
  const handleDownload = async () => {
    const buffer = await logsApi(
      logService.download({
        namespace: props.namespace,
        pod: props.pod,
        podId: props.podId,
        podIp: props.podIp,
        container: props.container,
        filename: props.fileName,
      }),
    );

    const array = new Uint8Array(buffer);

    const blob = new Blob([array], {
      type: "application/octet-stream",
    });

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${props.pod}_${props.container}_${props.fileName}`;
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);
  };

  return (
    <Button
      className={styles["download-button"]}
      testId={`S${props.pod}-${props.container}-${props.fileName}-download-btn`}
      onClick={handleDownload}
    >
      <DownloadIcon />
    </Button>
  );
};
